export default {
  items: [
    {
      name: 'Início',
      url: '/',
      icon: 'icon-home'
    },		
    {
      name: 'Manual de Utilização',
      url: 'https://www.bancorbras.com.br/media/272216/manual-portal-reserva.pdf',
      icon: 'fa fa-book fa-lg',
      attributes: { target: '_blank', rel: "noopener" },
    },
    {
      name: 'Reserva',
      url: '/',
      icon: 'icon-calendar',
      children: [
        {
          name: 'Pesquisar reservas',
          url: '/',
          icon: 'cui-magnifying-glass'
        },
        {
          name: 'Solicitação EB',
          url: '/',
          icon: 'fa fa-users fa-lg'
        },
        {
          name: 'Pedido de revisão',
          url: '/',
          icon: 'fa fa-file-text-o fa-lg'
        },
        {
          name: 'Alteração de reserva',
          url: '/',
          icon: 'fa fa-calendar-check-o fa-lg'
        },
        {
          name: 'Cancelamentos',
          url: '/',
          icon: 'fa fa-ban fa-lg'
        },
        {
          name: 'Rooming List',
          icon: 'fa fa-list fa-lg',
          children: [
            {
              name: 'Temporário',
              url: '/'
            },
            {
              name: 'Definitivo',
              url: '/'
            },
            {
              name: 'Comunicado de Novas Reservas',
              url: '/'
            },
          ]
        }
      ]
    },
    {
      name: 'Alterar senha',
      url: '/',
      icon: 'fa fa-key fa-lg'
    }
  ]
}
